export default "__VITE_ASSET__0366a8a5__"